import { useComponentState } from "@faedev/dynamic-values";
import { composeClassNames, withDefault } from "@faedev/editor-utils";
import { CSSProperties, ReactNode, useRef, useState } from "react";
import { Accordion, AccordionCollapse, AccordionToggle } from "react-bootstrap";
import Translate from "src/components/Translate";
import useEffect from "src/functions/useEffect";
import { sButton } from "src/styles/sButton.module.scss";
import { sReadMore } from "src/styles/sReadMore.module.scss";

type Props = {
  style?: CSSProperties | null | undefined;
  className?: (string | string) | null | undefined;
  rowsVisible?: number | null | undefined;
  rowsCount?: number | null | undefined;
  children?: ReactNode | any;
};

function ReadMore({
  style,
  className,
  rowsVisible,
  rowsCount,
  children,
}: Props) {
  let toggleAccordion = useComponentState(false);
  const targetRef = useRef();
  const [accordionHeight, setAccordionHeight] = useState({ height: 0 });
  const toggleVisible =
    withDefault(rowsCount, 1) > withDefault(rowsVisible, 0) ? true : false;
  useEffect(() => {
    const handleResize = () =>
      setAccordionHeight({
        height: targetRef.current ? targetRef.current["offsetHeight"] : 0,
      });
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  return (
    <>
      <Accordion
        defaultActiveKey={`1`}
        className={composeClassNames([
          sReadMore,
          className,
          `rows-` + String(withDefault(rowsVisible, 0)),
          `read-more`,
          toggleVisible && `toggle-visible`,
        ])}
        style={style}
      >
        <div ref={targetRef}>
          <AccordionCollapse
            eventKey={`0`}
            style={{ minHeight: `${accordionHeight.height}px` }}
          >
            {children}
          </AccordionCollapse>
        </div>
        {toggleVisible ? (
          <AccordionToggle
            eventKey={`0`}
            className={composeClassNames([
              sButton,
              "btn",
              "btn-primary",
              "btn-link",
            ])}
          >
            <Translate tKey={`Read the full description`} />
          </AccordionToggle>
        ) : null}
      </Accordion>
    </>
  );
}

export default ReadMore;
